import { Box } from "@mui/material";
import styled from "styled-components";

export const FormContainerStyled = styled(Box)`
  padding: 31px 0;
`;
